/**
 * A variant's own bottle (D19 phase 10): the picture the rider app shows (DesiGo Fleet's variant art, the owner's
 * assets, 2026-10-01), so G, G+, HG++ look the same on the phone and in the ERP. A code with no picture keeps its
 * colour dot. The code always stays written beside it: the picture is never the only sign of which milk it is.
 */
import { cx } from './primitives';

const FILE: Record<string, string> = {
  G: 'g', 'G+': 'g_plus', 'G++': 'g_plusplus', 'GPW++': 'gpw_plusplus', HG: 'hg', 'HG+': 'hg_plus', 'HG++': 'hg_plusplus', W: 'w',
};

export function variantBottleSrc(code: string): string | null {
  const f = FILE[code.trim().toUpperCase()];
  return f ? `/variants/${f}.webp` : null;
}

export function VariantBottle({ code, size = 22, withCode = true, className }: { code: string; size?: number; withCode?: boolean; className?: string }) {
  const src = variantBottleSrc(code);
  return (
    <span className={cx('inline-flex items-center gap-1.5 align-middle', className)}>
      {src
        ? <img src={src} alt="" aria-hidden width={Math.round(size * 0.78)} height={size} loading="lazy" className="shrink-0 object-contain" style={{ height: size, width: 'auto' }} />
        : <span aria-hidden className="inline-block h-2 w-2 shrink-0 rounded-full bg-ink-faint" />}
      {withCode && <span className="code-text">{code}</span>}
    </span>
  );
}
